/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  {
    openEditBenefisPage,
    allowEdit,
    openDeleteBenefisPage,
    openEditBenefisOrganizationPage,
    openEditBenefisIndividualPage,
    setDeleteModal,
    setRowId,
    blockOrg
  }
) => (
  <>
    {allowEdit && (
      <OverlayTrigger
        overlay={<Tooltip id="products-edit-tooltip">Edit Benefis</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
          onClick={() => {
            row.type == "INDIVIDU"
              ? openEditBenefisIndividualPage(row.uuid)
              : openEditBenefisOrganizationPage(row.uuid);
          }}
        >
          {row.id}
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>
    )}

    <> </>
    {blockOrg && (
    <OverlayTrigger
      overlay={<Tooltip id="products-delete-tooltip">Delete Kategori</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-danger btn-sm"
        onClick={() => {
          setDeleteModal(true);
          setRowId(row.uuid);
        }}
      >
        <span className="svg-icon svg-icon-md svg-icon-danger">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
        </span>
      </a>
    </OverlayTrigger>
    )}
  </>
);
